import {
  Directive,
  ElementRef,
  effect,
  input,
  OnDestroy,
  Renderer2
} from '@angular/core';
import {buildImageUrl, buildSrcSet, getImageSizes} from '../utils/image-source';
import {ImageMode} from '../utils/image-mode';

@Directive({
  selector: '[homeyImage]',
  standalone: true,
})
export class HomeyImageDirective implements OnDestroy {
  public readonly homeyImage = input.required<ImageMode>();
  public readonly homeyImageSrc = input<string>();

  private readonly stopEffect = effect(() => {
    const size = this.homeyImage();
    const providedSource = this.homeyImageSrc();
    const source = providedSource ?? this.elementRef.nativeElement.getAttribute('src');

    this.updateAttributes(size, source);
  });

  constructor(
    private readonly elementRef: ElementRef<HTMLImageElement>,
    private readonly renderer: Renderer2,
  ) {}

  ngOnDestroy() {
    this.stopEffect.destroy();
  }

  private updateAttributes(size: ImageMode | undefined, source: string | null) {
    if (!size || !source) {
      this.renderer.removeAttribute(this.elementRef.nativeElement, 'srcset');
      this.renderer.removeAttribute(this.elementRef.nativeElement, 'sizes');
      return;
    }

    const mainUrl = buildImageUrl(source, size);
    this.renderer.setAttribute(this.elementRef.nativeElement, 'src', mainUrl);

    const srcset = buildSrcSet(source, size);
    this.renderer.setAttribute(this.elementRef.nativeElement, 'srcset', srcset);

    const sizes = getImageSizes(size);
    this.renderer.setAttribute(this.elementRef.nativeElement, 'sizes', sizes);
  }

}
